import React from 'react';

interface GeneratedResultsProps {
    images: string[];
    onStartNew: () => void;
    onDownload: (url: string, index: number) => void;
    onNavigateToCanvas: (url: string, tool: 'video-generation' | 'upscaler') => void;
}

export const GeneratedResults: React.FC<GeneratedResultsProps> = ({
    images,
    onStartNew,
    onDownload,
    onNavigateToCanvas,
}) => {
    return (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-6">
            <div className="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <h3 className="text-lg font-semibold text-gray-900">Generated Results</h3>
                <button onClick={onStartNew} className="text-sm font-medium text-secondary-600 hover:text-secondary-800">
                    Start New Workflow
                </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {images.map((url, idx) => (
                    <div
                        key={idx}
                        className="relative flex flex-col h-96 bg-gradient-to-br from-gray-50 via-gray-100 to-gray-50 rounded-xl shadow hover:shadow-lg overflow-hidden border border-gray-100"
                    >
                        <div className="absolute top-3 left-3 z-10 bg-secondary-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">#{idx + 1}</div>
                        <div className="flex-1 flex items-center justify-center p-3">
                            <img src={url} alt={`Result ${idx + 1}`} className="max-h-72 max-w-full object-contain rounded-lg bg-white" />
                        </div>
                        <div className="flex justify-center gap-2 px-3 py-2 bg-gray-50 border-t border-gray-100">
                            <button
                                className="text-gray-600 hover:text-secondary-600 hover:bg-white border border-gray-200 hover:border-secondary-300 px-2.5 py-1.5 rounded-lg text-xs font-medium"
                                onClick={() => onDownload(url, idx)}
                            >
                                Download
                            </button>
                            <button
                                className="text-gray-600 hover:text-secondary-600 hover:bg-white border border-gray-200 hover:border-secondary-300 px-2.5 py-1.5 rounded-lg text-xs font-medium"
                                onClick={() => onNavigateToCanvas(url, 'video-generation')}
                            >
                                Create Video
                            </button>
                            <button
                                className="text-gray-600 hover:text-secondary-600 hover:bg-white border border-gray-200 hover:border-secondary-300 px-2.5 py-1.5 rounded-lg text-xs font-medium"
                                onClick={() => onNavigateToCanvas(url, 'upscaler')}
                            >
                                HD
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
